const DB_NAME = 'TripleATravelDB';
const DB_VERSION = 1;
const TRIPS_STORE = 'trips';
const CACHE_META_STORE = 'cache_meta';

const openDB = () => {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, DB_VERSION);
    request.onerror = () => reject(request.error);
    request.onsuccess = () => resolve(request.result);
    request.onupgradeneeded = (event) => {
      const db = event.target.result;
      if (!db.objectStoreNames.contains(TRIPS_STORE)) {
        db.createObjectStore(TRIPS_STORE, { keyPath: 'id' });
      }
      if (!db.objectStoreNames.contains(CACHE_META_STORE)) {
        db.createObjectStore(CACHE_META_STORE, { keyPath: 'key' });
      }
    };
  });
};

export const saveTripsOffline = async (trips) => {
  try {
    const db = await openDB();
    const tx = db.transaction([TRIPS_STORE, CACHE_META_STORE], 'readwrite');
    const tripsStore = tx.objectStore(TRIPS_STORE);
    const metaStore = tx.objectStore(CACHE_META_STORE);

    // Clear old trips and add fresh ones
    tripsStore.clear();
    trips.forEach((trip) => tripsStore.put(trip));

    // Save cache timestamp
    metaStore.put({ key: 'trips_cached_at', value: new Date().toISOString() });

    await new Promise((resolve, reject) => {
      tx.oncomplete = resolve;
      tx.onerror = () => reject(tx.error);
    });
    db.close();
  } catch { /* silent */ }
};

export const getOfflineTrips = async () => {
  try {
    const db = await openDB();
    const tx = db.transaction([TRIPS_STORE, CACHE_META_STORE], 'readonly');
    const tripsStore = tx.objectStore(TRIPS_STORE);
    const metaStore = tx.objectStore(CACHE_META_STORE);

    const trips = await new Promise((resolve, reject) => {
      const req = tripsStore.getAll();
      req.onsuccess = () => resolve(req.result);
      req.onerror = () => reject(req.error);
    });

    const meta = await new Promise((resolve, reject) => {
      const req = metaStore.get('trips_cached_at');
      req.onsuccess = () => resolve(req.result?.value || null);
      req.onerror = () => reject(req.error);
    });

    db.close();
    return { trips, cachedAt: meta };
  } catch (err) {
    return { trips: [], cachedAt: null };
  }
};

export const saveTripDetailOffline = async (trip) => {
  try {
    const db = await openDB();
    const tx = db.transaction(TRIPS_STORE, 'readwrite');
    tx.objectStore(TRIPS_STORE).put(trip);
    await new Promise((resolve, reject) => {
      tx.oncomplete = resolve;
      tx.onerror = () => reject(tx.error);
    });
    db.close();
  } catch { /* silent */ }
};

export const getOfflineTripDetail = async (tripId) => {
  try {
    const db = await openDB();
    const tx = db.transaction(TRIPS_STORE, 'readonly');
    const result = await new Promise((resolve, reject) => {
      const req = tx.objectStore(TRIPS_STORE).get(tripId);
      req.onsuccess = () => resolve(req.result || null);
      req.onerror = () => reject(req.error);
    });
    db.close();
    return result;
  } catch (err) {
    return null;
  }
};

export const clearOfflineData = async () => {
  try {
    const db = await openDB();
    const tx = db.transaction([TRIPS_STORE, CACHE_META_STORE], 'readwrite');
    tx.objectStore(TRIPS_STORE).clear();
    tx.objectStore(CACHE_META_STORE).clear();
    await new Promise((resolve, reject) => {
      tx.oncomplete = resolve;
      tx.onerror = () => reject(tx.error);
    });
    db.close();
  } catch { /* silent */ }
};
